import React, {useState} from "react";
import { Table } from "reactstrap";
import { Link } from "react-router-dom";

import CasosDesplazVer from "./componentsCasosModal/CasosDesplazVer";
import {  useDispatch } from "react-redux";
import '../styles/Table.css'

import { casosUpdate } from "../../../store/casos/actions";

import ModalObservaciones from "./casosDesplazamiento/ModalObservaciones";

const TableCasos = ({
  handleEspera,
  groups,
  casos,
  handleINICIADO,
  handleaddclick,
}) => {
  const [verModal, setVerModal] = useState(false);
  const [Item, setItem] = useState(false);

  const dispatch = useDispatch();

  const handleCasoClick = (item) => {
    setVerModal(true);
    setItem(item);
  };

  const handleCloseModal = () => {
    setVerModal(false);
  };


  const FinalizarCasoDesplazamiento = (id) => {
    dispatch(casosUpdate(`${id}`, {
      estatus: 'FINALIZAR'
    }));
  }


  const [observacionModal, setobservacionModal] = useState(false)

  const handleobservacionModal = (item) => {
    setobservacionModal(true);
      setItem(item);
    };
  
    const handleCloseModalObservaciones = () => {
      setobservacionModal(false);
    };
   

  return (


    <React.Fragment>


{verModal ? (
        <CasosDesplazVer
          verModal={verModal}
          onCloseClick={handleCloseModal}
          Item={Item}
        ></CasosDesplazVer>
      ) : null}

{observacionModal ? (
        <ModalObservaciones
          verModal={observacionModal}
          onCloseClick={handleCloseModalObservaciones}
          Item={Item}
        ></ModalObservaciones>
      ) : null}


      <Table
        className="table table-bordered table-striped text-center mb-3"
        hover
      >
        <thead>
          <tr>
            <th>Numero</th>
            <th>Fecha de Creacion </th>
            <th>Fecha de Asignacion </th>
            <th>Lapso de Hora para ir </th>

            <th>Contacto o PreContacto </th>
            <th>Estatus </th>
            <th>Grupo de Tecnicos </th>

            <th>Tecnico asignado </th>
            <th>Accion </th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(casos)
            ? casos.map((item) => {
                const estatusinabilit = item.estatus;

                return (
                  <tr key={item.id}>
                    {item.modelo_desplazamiento === true ? (
                      <th
                      className="th-caso"
                      onClick={() => handleCasoClick(item)}
                      >
                     
                          {item.id}
                      
                      </th>
                    ) : (
                      <th>
                        <Link to={`/casos/${item.id}/edit_caso`}>
                          {" "}
                          {item.id}
                        </Link>
                      </th>
                    )}
                    <th> {item.created_date}</th>
                    <th> {item.fecha_asignacion}</th>
                    {item.estatus === "EN ESPERA" ? (
                      <th> </th>
                    ) : (
                      <th>
                        {item.lapso_hora_entrada} a {item.lapso_hora_salida}
                      </th>
                    )}
                    <th>
                      {" "}
                      {item.pre_contacto === null
                        ? item.contacto
                        : item.pre_contacto}
                    </th>

                    <th>
                      {(function Status() {
                        if (item.estatus === "ACEPTAR") {
                          return (
                            <div className="badge rounded-pill bg-danger  fontSize-13">
                              <strong>ACEPTADO</strong>{" "}
                            </div>
                          );
                        }
                        if (item.estatus === "INICIAR") {
                          return (
                            <div
                              className="badge rounded-pill bg-dark
                                                    fontSize-13"
                            >
                              <strong>INICIADO</strong>{" "}
                            </div>
                          );
                        }
                        if (item.estatus === "ASIGNADO") {
                          return (
                            <div className="badge rounded-pill bg-warning  fontSize-13">
                              <strong>ASIGNADO</strong>{" "}
                            </div>
                          );
                        }
                        if (item.estatus === "PAUSAR") {
                          return (
                            <div className="badge rounded-pill bg-secondary  fontSize-13">
                              <strong>PAUSADO</strong>{" "}
                            </div>
                          );
                        }
                        if (item.estatus === "FINALIZAR") {
                          return (
                            <div className="badge rounded-pill bg-success fontSize-13">
                              <strong>FINALIZADO</strong>{" "}
                            </div>
                          );
                        }

                        if (item.estatus === "EN ESPERA") {
                          return (
                            <div className="badge rounded-pill bg-info fontSize-13">
                              <strong>EN ESPERA</strong>{" "}
                            </div>
                          );
                        }
                        if (item.estatus === "REINICIAR") {
                          return (
                            <div className="badge rounded-pill bg-info fontSize-13">
                              <strong>REINICIADO</strong>{" "}
                            </div>
                          );
                        }
                      })()}
                    </th>

                    <td>{item.grupo_tecnico}</td>
                    <td style={{ width: "225.22222px" }}>
                      {item.tecnico_asignado.join(", ")}
                    </td>

{/* butons para casos desplazamiento */}

{item.modelo_desplazamiento === true ? (
  <th>
        {item.estatus === 'INICIAR' || item.estatus === 'REINICIAR'  ?(
                                  <button

                                  className={`btn btn-sm  btn-secondary`}
                                  style={{marginRight:'10px',
                                  pointerEvents:
                                  estatusinabilit === "FINALIZAR" &&
                                  item.estatus !== "EN ESPERA"
                                    ? "none"
                                    : "auto",
                                }}
                                 
                                  onClick={()=> {handleobservacionModal(item)}}
                                  >
                                    PAUSAR
                                  </button>
                                ):null}

                            {estatusinabilit !== "FINALIZAR" ? (
                              <button
                                className="btn btn-sm btn-primary waves-effect waves-light "
                                id="disabled"
                                style={{
                                  pointerEvents:
                                    estatusinabilit === "FINALIZAR" &&
                                    item.estatus !== "EN ESPERA"
                                      ? "none"
                                      : "auto",
                                }}
                                onClick={(e) =>
                                  item.estatus === "EN ESPERA"
                                    ? handleEspera(item.id)
                                    : item.estatus === "INICIAR" || item.estatus === "REINICIAR"
                                    ? FinalizarCasoDesplazamiento(item.id)
                                    : handleaddclick(item.id)
                                }
                                disabled={
                                  estatusinabilit === "FINALIZAR" ||
                                  (groups === "SuperAdmin" &&
                                    item.estatus !== "EN ESPERA")
                                    ? true
                                    : false
                                }
                                // disabled={false}
                              >
                                {item.estatus === "FINALIZAR"
                                  ? "FINALIZADO"
                                  : item.estatus === "ASIGNADO"
                                  ? "ACEPTAR"
                                  : item.estatus === "ACEPTAR"
                                  ? "INICIAR"
                                  : item.estatus === "EN ESPERA"
                                  ? "ASIGNAR"
                                  : item.estatus === "PAUSAR"
                                  ? "REINICIAR"
                                  : item.estatus === "INICIAR"
                                  ? "FINALIZAR"
                                  : (item.estatus === "REINICIAR" && item.modelo_desplazamiento=== false)
                                  ? "PAUSAR"
                                  : (item.estatus === "REINICIAR" && item.modelo_desplazamiento=== true)
                                  ? "FINALIZAR"
                                  : ""}
                              </button>


                             
                            ) : null}

  </th>
) : (
  /* Butons para casos normales */
  <th>
    <button
      className="btn btn-primary waves-effect waves-light"
      id="disabled"
      onClick={(e) =>
        item.estatus === "EN ESPERA"
          ? handleEspera(item.id)
          : item.estatus === "INICIAR"
          ? handleINICIADO(item.id)
          : handleaddclick(item.id)
      }
      disabled={
        estatusinabilit === "FINALIZAR" ||
        (groups === "SuperAdmin" && item.estatus !== "EN ESPERA")
          ? true
          : false
      }
    >
      {item.estatus === "FINALIZAR"
        ? "FINALIZADO"
        : item.estatus === "ASIGNADO"
        ? "ACEPTAR"
        : item.estatus === "ACEPTAR"
        ? "INICIAR"
        : item.estatus === "EN ESPERA"
        ? "ASIGNAR"
        : item.estatus === "PAUSAR"
        ? "REINICIAR"
        : item.estatus === "INICIAR"
        ? "FINALIZAR"
        : item.estatus === "REINICIAR"
        ? "PAUSAR"
        : ""}
    </button>
  </th>
)}

                  </tr>
                );
              })
            : []}
        </tbody>
      </Table>
    </React.Fragment>
  );
};

export default TableCasos;
